import { on } from 'js/lib/events'
import { createAnalyticsGroup } from 'js/lib/analytics'

const track = createAnalyticsGroup('banners')

on('click', '.js-c-valentines-day-promo-banner__cta', function () {
  track('click', 'valentines day promo')
})
